import BaseViewerController from "./base_viewer_controller"
import * as XLSX from 'xlsx'

export default class extends BaseViewerController {
  static targets = ["container", "sheetSelector", "currentSheetName", "sheetMenu"]
  static values = {
    url: String
  }

  currentSheet = null

  connect() {
    super.connect()
    this.initializeViewer()
  }

  initializeViewer() {
    if (!this.hasContainerTarget) {
      console.error('Container target not found')
      return
    }

    this.loadExcelFile()
  }

  async loadExcelFile() {
    try {
      const response = await fetch(this.urlValue)
      if (!response.ok) {
        throw new Error(`Failed to fetch Excel file: ${response.statusText}`)
      }

      const arrayBuffer = await response.arrayBuffer()
      this.workbook = XLSX.read(arrayBuffer, { type: 'array' })

      if (this.workbook.SheetNames.length === 0) return

      const firstSheet = this.workbook.SheetNames[0]
      this.renderSheet(firstSheet)

      if (this.workbook.SheetNames.length > 1) {
        this.renderSheetSelector()
      }
    } catch (error) {
      console.error('Error loading Excel file:', error)
      this.handleError('Failed to load Excel file')
    }
  }

  renderSheet(sheetName) {
    const sheet = this.workbook.Sheets[sheetName]
    if (!sheet) {
      console.error(`Sheet "${sheetName}" not found`)
      return
    }

    this.currentSheet = sheetName
    if (this.hasCurrentSheetNameTarget) {
      this.currentSheetNameTarget.textContent = sheetName
    }

    const html = XLSX.utils.sheet_to_html(sheet, { id: 'excel-table' })
    this.containerTarget.innerHTML = html

    const table = this.containerTarget.querySelector('table')
    if (!table) return

    table.className = 'table-spreadsheet text-xs'
  }

  renderSheetSelector() {
    if (!this.hasSheetMenuTarget) {
      console.warn('Sheet menu target not found')
      return
    }

    this.sheetMenuTarget.innerHTML = ''
    this.workbook.SheetNames.forEach(sheetName => {
      const menuItem = document.createElement('button')
      menuItem.type = 'button'
      menuItem.className = 'w-full px-3 py-2 flex items-center gap-2 text-left text-sm whitespace-nowrap transition-colors duration-200 cursor-pointer text-content hover:bg-surface-dark hover:bg-opacity-80 hover:rounded-lg first:rounded-t-lg last:rounded-b-lg'
      menuItem.textContent = sheetName
      menuItem.dataset.action = 'click->excel-viewer#selectSheet click->dropdown#hide'
      menuItem.dataset.sheetName = sheetName
      this.sheetMenuTarget.appendChild(menuItem)
    })
    this.sheetSelectorTarget.classList.remove('hidden')
  }

  selectSheet(event) {
    const sheetName = event.currentTarget.dataset.sheetName
    if (sheetName && sheetName !== this.currentSheet) {
      this.renderSheet(sheetName)
    }
  }

  cleanup() {
    super.cleanup()
    this.workbook = null
  }
}
